module.exports = __webpack_public_path__ + "8dfde9be220eb9f688220e10aec04c05.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/fries.png
// module id = 2527
// module chunks = 0